<div class="feed-table-wrapper">
<div class="select-head scrollbar" id="scrollcustom" style="display: flex; flex-direction: column">
 <div class="header-wrapper">
<div class="btns" *ngIf="showBackToNewTask">
  <button mat-flat-button (keydown)="backToNewTask()" (click)="backToNewTask()">
    Back to New Task
  </button>
</div>
 </div>
     <!-- Industry selection -->
      <div *ngIf="!industryTypes" class="load">Loading indices details...</div>
      <div class="sensor-outer-container">
        <div class="sensor-outer-wrapper">
          <div class="info-text">
            <p>Select industries to preview indices</p>
          </div>
          <div class="mat-ls">
            <div *ngFor="let industry of industryTypes; let i = index" class="sensor-checkbox">
              <span>
                <mat-checkbox
                  [(ngModel)]="industry.selected"
                  [checked]="industry.selected"
                  (ngModelChange)="industryTypeChange(industry,i); "
                >
                  <span class="sensor-label">{{ industry.name }}
                    <img *ngIf="industry.description"
                      alt=""
                      [src]="tooltipImagePath"
                      style="margin: 0 0 4px 5px"
                      matTooltip="{{ industry.description }}"
                  /></span>
                </mat-checkbox>
              </span>
            </div>
          </div>
        </div>
      
      </div>
  <div class="cs-table">
    <table *ngIf="dataSource.data.length"
      mat-table
      [dataSource]="dataSource"
      matSort
      class="feed-table">

      <ng-container matColumnDef="indexName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
          Index name
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.indexName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
          Description
        </th>
        <td mat-cell *matCellDef="let row"  class="description-col">
          {{ row.description }}
        </td>
      </ng-container>

      <ng-container matColumnDef="useCase">
        <th mat-header-cell *matHeaderCellDef style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
          Use case
        </th>
        <td mat-cell *matCellDef="let row"  class="align-item-center">
          <ul style="padding-left: 16px;">
            <li *ngFor="let use of row.useCase">
              {{ use }}
            </li>
          </ul>
        </td>
      </ng-container>

      <ng-container matColumnDef="qualifiedOperator">
        <th mat-header-cell *matHeaderCellDef style="align-items: center;color: #fff; font-size: 14px; height: 10px;text-align: left; font-weight: 400; cursor: pointer;">
          Qualified operator(s)
        </th>
        <td mat-cell *matCellDef="let row"  class="align-item-center">
          <ul style="padding-left: 16px;">
            <li *ngFor="let operator of row.qualifiedOperator">
              {{ operator }}
            </li>
          </ul>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>
  </div>
    <app-notask *ngIf="selectedIndustryList.length != 0 && dataSource.data.length === 0" [indices]=true></app-notask>

 </div>
</div>
